import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAdmin } from '../lib/useIsAdmin';

export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { loading, isAdmin } = useIsAdmin();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-ink-muted text-sm font-mono">checking access…</div>
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
